import classnames from 'classnames';
import autobind from 'core-decorators/lib/autobind';
import { WixConnect } from 'shared/utils/wix-connect';

import styles from './scrollbar-wrapper.styl';


@WixConnect(styles)
class ScrollbarWrapper extends React.Component {

  static propTypes = {
    scrollX: React.PropTypes.bool,
    scrollY: React.PropTypes.bool,
    onlyOnHover: React.PropTypes.bool,
    getRef: React.PropTypes.func,
  };

  static defaultProps = {
    scrollX: false,
    scrollY: true,
    onlyOnHover: false,
    getRef: _.noop,
  };

  @autobind
  getRef(node) {
    if (!node) {
      return;
    }

    this.props.getRef(node);
  }

  render() {
    const { onlyOnHover, scrollX, scrollY } = this.props;
    const props = _.pick(this.props, 'className', 'children');

    const classNames = classnames('scrollbar-wrapper', {
      'only-on-hover': onlyOnHover,
      'scroll-x': scrollX,
      'scroll-y': scrollY,
    });

    return (
      <div {...props}
           ref={this.getRef}
           styleName={classNames} />
    );
  }
}


@WixConnect(styles)
export class BackOfficeScrollbarWrapper extends React.Component {
  render() {
    const props = _.omit(this.props, 'styles');

    return (
      <ScrollbarWrapper {...props}
                        styleName="backoffice" />
    );
  }
}


@WixConnect(styles)
export class WidgetScrollbarWrapper extends React.Component {
  render() {
    const props = _.omit(this.props, 'styles');

    return (
      <ScrollbarWrapper {...props}
                        styleName="widget" />
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/scrollbar-wrapper/scrollbar-wrapper.js